enum EnumWorkshopTypes {
    QUICK_START = 0, SCHEDULED
}

enum EnumWorkshopActivity {
    GENERAL = 1, PROBLEM_ANALYSIS, CONSTRUCTION, DECONSTRUCTION, PROBLEM_TREE, OBJECTIVE_TREE
}

enum EnumStatus {
    INACTIVE, ACTIVE, IN_PROGRESS, COMPLETED
}

enum EnumFeatures {
    team = 'Teams',
    project = 'Projects',
    stories = 'Enterprise Stories',
    reports = 'Reports',
    assessments = 'Assessments',
    workshops = 'Workshops',
    metrics = 'Metrics'
}

enum EnumGoJSNodeTypes {
    FOCAL_PROBLEM = 0, EFFECT, CAUSE, SIBLING
}

enum EnumDialogTypes {
    ALERT, PROMPT, CONFIRM, DROP_DOWN
}


export enum EnumCRUDMutations { ADD = 0, UPDATE, DELETE }


export class FolioEnums {
    static activity = EnumWorkshopActivity;
    static status = EnumStatus;
    static features = EnumFeatures;
    static workshopTypes = EnumWorkshopTypes;
    static gojsNodeTypes = EnumGoJSNodeTypes;
    static folioDialogType = EnumDialogTypes;
}
